import {Component, Inject} from 'ng-metadata/core';
import { SharedSessionStorage } from '../../infra/sharedSessionStorage.service';
import { PersonalizeResultsButtonService } from '../../search/personalization/personalizationButton/personalizeResultsButton.service';
import { OrganizationOrFacetToggleService } from './organization-or-facet-toggle.service';


@Component({
    selector: 'prm-organization-or-facet-toggle',
    templateUrl: 'components/journals/organizationOrFacetToggle/organization-or-facet-toggle.html',
})



export class PrmOrganizationOrFacetToggle {  
   
    
    constructor(
            private organizationOrFacetService: OrganizationOrFacetToggleService,
            @Inject('$translate') private $translate: ng.translate.ITranslateService) {  
    }

    changeToggle() {
        this.organizationOrFacetService.isOrganizationTree = !this.organizationOrFacetService.isOrganizationTree;
    }
    
    get isOrganizationTree(): boolean {
        return this.organizationOrFacetService.isOrganizationTree;
    }
    
    public getOrganizationTreeTooltip(){
        return (this.isOrganizationTree) ? this.$translate.instant('nui.organizationtree.icon.tooltip.gotofacets') : this.$translate.instant('nui.organizationtree.icon.tooltip.gotoresearchunits');
    }
    
    public getOrganizationTreeLabel(){
        return (this.isOrganizationTree) ? this.$translate.instant('nui.organizationtree.icon.label.gotofacets') : this.$translate.instant('nui.organizationtree.icon.label.gotoresearchunits');
    }



}


// WEBPACK FOOTER //
// ./src/main/webapp/components/journals/organizationOrFacetToggle/organization-or-facet-toggle.directive.ts